import generatePupilHtmlMetadata from '@/config/brandings/pupil/headerTags.ts'
import { getNativeConfig } from 'src/config/brandings/pupil/nativeConfig.ts'

module.exports = () => {
  const headerTags = generatePupilHtmlMetadata()
  return {
    app_name: 'PUPIL Connect',
    styles: {
      load: () => import(/* webpackChunkName: "styleOSS" */'src/config/brandings/pupil/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: headerTags.meta.appleItunesApp },
        { name: 'application-name', content: headerTags.meta.applicationName },
        { name: 'author', content: headerTags.meta.author },
        { name: 'copyright', content: headerTags.meta.copyright },
        { name: 'description', content: headerTags.meta.description },
        { name: 'og:image', content: headerTags.meta.open_graph.image },
        { name: 'og:title', content: headerTags.title },
        { name: 'og:url', content: headerTags.meta.open_graph.url },
        { name: 'og:author', content: headerTags.meta.author },
        { name: 'og:description', content: headerTags.meta.description },
        { name: 'twitter:image', content: headerTags.meta.open_graph.image },
        { name: 'twitter:url', content: headerTags.meta.open_graph.url },
        { name: 'twitter:title', content: headerTags.title },
        { name: 'twitter:description', content: headerTags.meta.description }
      ],
      link: [
        { rel: 'shortcut icon', href: headerTags.link.favIcon, type: 'image/png' },
        { rel: 'copyright', href: headerTags.link.copyrightLink }
      ]
    },
    logos: {
      logo: 'brandings/pupil/logo/pupil-seven-education-logo.svg'
    },
    search: {
      queries: {
        branding: 'PUPIL'
      }
    },
    start: {
      description: 'branding.pupil.start.description',
      image: 'brandings/pupil/start/pupil-start-logo.svg',
      show_more: false,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'branding.pupil.management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: false,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: false
    },
    onboarding: {
      help_videos: true
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: false,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: true,
      form: {
        inline_reset_password: false
      }
    },
    ...getNativeConfig()
  }
}
